export default __webpack_public_path__ + "static/media/diamong-league-logo.b9949cae.png";